import { getAppConfigSetting } from '../utils'

export const WITH_CREDENTIALS_CONFIG = {
  withCredentials: true,
}

export const ACCOUNTS_API = `${getAppConfigSetting(
  'apiUrl'
)}/atlas/api/v1/accounts`

export const ACCOUNT_UPDATE_API = (accountNumber: string) =>
  `${getAppConfigSetting(
    'apiUrl'
  )}/account-update/api/v1/account/${accountNumber}`

export const ACTIVITIES_API = `${getAppConfigSetting(
  'apiUrl'
)}/activities-provider/api/v1/activities`

export const getAuthorizedTradersApi = (accountNumber: string) =>
  `${getAppConfigSetting(
    'apiUrl'
  )}/atlas/api/v1/accounts/${accountNumber}/authorized_traders`

export const getInvestmentProfileApi = (accountNumber: string) =>
  `${getAppConfigSetting(
    'apiUrl'
  )}/atlas/api/v1/accounts/${accountNumber}/investment_profile`

export const BALANCES_API = `${getAppConfigSetting(
  'apiUrl'
)}/balance-provider/api/v2/balances`

export const CORRESPONDENTS_API = `${getAppConfigSetting(
  'apiUrl'
)}/correspondent-provider/api/v2/correspondents`

export const getAccountNotesApi = (accountNumber: string) =>
  `${getAppConfigSetting(
    'apiUrl'
  )}/atlas/api/v1/accounts/${accountNumber}/scratch_pad`

export const TRADING_RESTRICTIONS_API = `${getAppConfigSetting(
  'apiUrl'
)}/trading-killswitch/api/v1/trading-restrictions/`

export const MARGIN_POSITION_API = `${getAppConfigSetting(
  'apiUrl'
)}/margin-provider/api/v1/positions`

export const MARGIN_CALLS_API = `${getAppConfigSetting(
  'apiUrl'
)}/margin-provider/api/v1/margin_calls`

export const MARGINS_API = `${getAppConfigSetting(
  'apiUrl'
)}/margin-provider/api/v1/margins`

export const getDocumentsApi = (accountNumber: string) =>
  `${getAppConfigSetting(
    'apiUrl'
  )}/atlas/api/v1/accounts/${accountNumber}/documents`

export const getEPreferencesApi = (accountNumber: string) =>
  `${getAppConfigSetting(
    'apiUrl'
  )}/atlas/api/v1/accounts/${accountNumber}/e_preferences`

export const WEBUSER_API = `${getAppConfigSetting(
  'apiUrl'
)}/webuser-provider/api/v1`

export const CASH_BALANCES_AVAILABLE_API = `${getAppConfigSetting(
  'apiUrl'
)}/cash-balances/api/v2`
